// PLUS ACSE LANDING PAGES

/* STATS.js - Moduł analityczny dla portali PLK-PLUSH-CP
Istnieje jako obiekt stats dostępny z konsoli - można tam zobaczyć status
W pierwszej kolejności sprawdza czy włączony jest adBlock
Następnie waliduje GTM oraz działa w jednym z trzech trybów:
valid = jeśli jest na produkcji i GTM sie waliduje
valid = false = jeśli GTM się nie waliduje zapisuje do własnego dataLayer
local = jeśli jest na localu zapisuje zdarzenia do własnego dataLayer w celu debugu
Walidacja będzie uruchamiana przy każdym zdarzeniu aż uda się zwalidować - wtedy już sie nie będzie odpalała
Uwaga - każda metoda znajdująca się w tym module to promise

Version 2.0 - od 08.06.2020
*/

function push(value) {
    if (!window) {
        return
    }
    if (!window.dataLayer) {
        window.dataLayer = []
    }
    window.dataLayer.push(value)
}

export const stats = (function () {
    const stats = {}
    stats.valid = null
    stats.local = null
    stats.container = null
    stats.dataLayer = []
    stats.userAgent
    stats.browser

    function checkValidity() {
        return new Promise((resolve) => {
            if (stats.valid === null && stats.local === null) {
                stats.local = !window.location.href.includes('localhost') ? null : true
                stats.valid = window.google_tag_manager ? true : null

                if (stats.valid) {
                    if (window.location.href.includes('polsatbox.pl')) {
                        stats.container = 'GTM-TCMVQC8'
                    } else if (window.location.href.includes('plus.pl')) {
                        stats.container = 'GTM-TDDS2K'
                    } else if (window.location.href.includes('plushbezlimitu.pl')) {
                        stats.container = 'GTM-P2CVJH'
                    }

                    const promise = new Promise((resolve) => {
                        stats.dataLayer.forEach((element) => push(element))
                        resolve()
                    })
                    promise.then(() => (stats.dataLayer = window.dataLayer)).then(() => resolve())
                } else {
                    resolve()
                }
            } else {
                resolve()
            }
        })
    }

    function hive_check(a, b) {
        if (a) {
            return (b.hive_diсt = a)
        }
    }

    function stats_push(obj) {
        return new Promise((resolve) => {
            checkValidity().then(() => {
                stats.dataLayer.push(obj)
                resolve()
            })
        })
    }

    function timer_check(timer, obj) {
        if (timer) {
            return (obj.timer = timer.stop())
        }
    }

    /*
    Ta metoda służy do generowania prostych zdarzeń - należy podać event, cateogry, action, label i opcjonalnie timer
    Przykład: stats.generic('GAevent','Listing ofert - Voice - IND', 'Click', 'Włączenie szczegółów oferty - Listing ofert',null,jakisHIVE))
    */

    stats.generic = function (
        event,
        {
            category,
            action,
            label,
            click_text = '',
            click_path = '',
            click_element = '',
            component_name = '',
            offer = '',
        },
        timer,
        hive,
    ) {
        return new Promise((resolve) => {
            const obj = {
                event,
                '1_category': category,
                '2_action': action,
                '3_label': label,
                '6_click_text': click_text,
                '7_click_path': click_path,
                '8_click_element': click_element,
                '9_component_name': component_name,
                '10_offer': offer,
                eventCallback(container) {
                    if (container == stats.container) {
                        resolve()
                    }
                },
            }

            timer_check(timer, obj)
            hive_check(hive, obj)
            push(obj)
            // stats_push(obj).then(() => resolve())
        })
    }

    /*
    Ta metoda ułatwiająca pushowanie GAevent, taka sama jak generic, tylko juz z wyznaczonym eventem
    Przykład: stats.ga('Listing ofert - Voice - IND', 'Click', 'Włączenie szczegółów oferty - Listing ofert'))
    */

    stats.ga = function (
        {
            category,
            action,
            label,
            click_text = '',
            click_path = '',
            click_element = '',
            component_name = '',
            offer = '',
        },
        timer,
        hive,
    ) {
        return new Promise((resolve) => {
            const obj = {
                event: 'GAevent',
                '1_category': category,
                '2_action': action,
                '3_label': label,
                '6_click_text': click_text,
                '7_click_path': click_path,
                '8_click_element': click_element,
                '9_component_name': component_name,
                '10_offer': offer,
                eventCallback(container) {
                    if (container == stats.container) {
                        resolve()
                    }
                },
            }

            timer_check(timer, obj)
            hive_check(hive, obj)
            push(obj)
            // stats_push(obj).then(() => resolve())
        })
    }

    /*
    Ta metoda ułatwiająca wysłanie GAevent
    */

    stats.handleGAEvent = function ({
        category,
        action,
        label,
        click_text,
        click_path,
        click_element,
        component_name,
        offer,
    }) {
        stats.ga(
            {
                category,
                action,
                label,
                click_text,
                click_path,
                click_element,
                component_name,
                offer,
            },
            0,
            `${category}_${action}`,
        )
    }

    /* stats.object
    Ta metoda pozwala na generowanie arbitralnych zdarzeń.
    Przykład: stats.object({'event': 'adblock','adblock': false});
    */

    stats.object = function (obj, timer) {
        return new Promise((resolve) => {
            obj.eventCallback = function (container) {
                if (container == stats.container) {
                    resolve()
                }
            }

            timer_check(timer, obj)
            push(obj)
            // stats_push(obj).then(() => resolve())
        })
    }

    /* Timer
    Do każdego zdarzenia można dodać timer.
    Np. jeśli chcemy zaraportować ile czasu zajęło ładowanie strony, odpalamy
    var listingTimer = new stats.timer();
    następnie, kiedy wiemy że wszystko jest już załadowane (np. Vue.created()), odpalamy
    stats.object({'event': 'listing_ready'}, listingTimer);
    */

    stats.timer = function () {
        let start = Date.now()
        this.stop = function () {
            const now = Date.now() - start
            return now
        }
        this.reset = function () {
            start = Date.now()
        }
    }

    stats.ecommerce = {
        impression() {
            let impressions = []
            this.add = (item) => impressions.push(item)
            this.clear = () => (impressions = [])
            this.push = (timer) =>
                new Promise((resolve) => {
                    const obj = {
                        "event": 'ecommerce_listing',
                        '1_category': 'Ecommerce',
                        '2_action': 'Listing',
                        '3_label': impressions[0].list,
                        "ecommerce": {
                            impressions,
                        },
                        eventCallback(container) {
                            if (container == stats.container) {
                                resolve()
                            }
                        },
                        "eventTimeout": 2000,
                    }

                    timer_check(timer, obj)

                    stats.object(obj).then(() => {
                        resolve()
                    })
                })
        },
        product() {
            /*
            Przykład:
            $('a.buy').on('click', function(e){
                e.preventDefault();

                var url = $(this).attr('href');
                var offer = $(this).closest('.offer');
                var obj = new stats.ecommerce.product();
                obj.add({
                    'id' : offer.attr('data-id'),
                    'name' : '',
                    'price' : offer.attr('data-price'),
                    'brand' : offer.attr('data-brand'),
                    'category' : offer.attr('data-category'),
                    'variant' : '',
                    'quantity' : 1,
                    'list' : offer.attr('data-list'),
                    'coupon' : offer.attr('data-bonus')
                });

                $.when(
                    obj.push()
                ).then(
                    window.location.href = url
                );
            });
            */

            let products = []
            this.add = (item) => products.push(item)
            this.clear = () => (products = [])
            this.push = (timer) =>
                new Promise((resolve) => {
                    const obj = {
                        "event": 'ecommerce',
                        '1_category': 'Ecommerce',
                        '2_action': 'Listing Click',
                        '3_label': products[0].category,
                        "ecommerce": {
                            click: {
                                actionField: {
                                    list: products[0].list ? products[0].list : products[0].category,
                                },
                                products,
                            },
                        },
                        eventCallback(container) {
                            if (container == stats.container) {
                                resolve()
                            }
                        },
                        "eventTimeout": 2000,
                    }

                    timer_check(timer, obj)

                    stats.object(obj).then(() => {
                        resolve()
                    })
                })
        },
        detail() {
            let products = []
            this.add = (item) => products.push(item)
            this.clear = () => (products = [])
            this.push = (timer) =>
                new Promise((resolve) => {
                    const obj = {
                        "event": 'ecommerce',
                        '1_category': 'Ecommerce',
                        '2_action': 'Product Details',
                        '3_label': products[0].category,
                        "ecommerce": {
                            detail: {
                                actionField: {},
                                products,
                            },
                        },
                        eventCallback(container) {
                            if (container == stats.container) {
                                resolve()
                            }
                        },
                        "eventTimeout": 2000,
                    }

                    timer_check(timer, obj)

                    stats.object(obj).then(() => {
                        resolve()
                    })
                })
        },
    }

    // sprawdzamy wersje przegladarki za pomoca useragent oraz regexp
    stats.check_browser = function () {
        const _ua = window.navigator.userAgent

        stats.browser = {
            version: (_ua.match(/.+(?:me|ox|on|rv|it|era|opr|ie)[/: ]([\d.]+)/) || [0, '0'])[1],
            opera: /opera/i.test(_ua) || /opr/i.test(_ua),
            msie: (/msie/i.test(_ua) && !/opera/i.test(_ua)) || /trident\//i.test(_ua),
            msie6: /msie 6/i.test(_ua) && !/opera/i.test(_ua),
            msie7: /msie 7/i.test(_ua) && !/opera/i.test(_ua),
            msie8: /msie 8/i.test(_ua) && !/opera/i.test(_ua),
            msie9: /msie 9/i.test(_ua) && !/opera/i.test(_ua),
            mozilla: /firefox/i.test(_ua),
            chrome: /chrome/i.test(_ua),
            safari: !/chrome/i.test(_ua) && /webkit|safari|khtml/i.test(_ua),
            iphone: /iphone/i.test(_ua),
            ipod: /ipod/i.test(_ua),
            iphone4: /iphone.*OS 4/i.test(_ua),
            ipod4: /ipod.*OS 4/i.test(_ua),
            ipad: /ipad/i.test(_ua),
            android: /android/i.test(_ua),
            bada: /bada/i.test(_ua),
            mobile: /iphone|ipod|ipad|opera mini|opera mobi|iemobile|android/i.test(_ua),
            msie_mobile: /iemobile/i.test(_ua),
            safari_mobile: /iphone|ipod|ipad/i.test(_ua),
            opera_mobile: /opera mini|opera mobi/i.test(_ua),
            opera_mini: /opera mini/i.test(_ua),
            mac: /mac/i.test(_ua),
            search_bot:
                /(yandex|google|stackrambler|aport|slurp|msnbot|bingbot|twitterbot|ia_archiver|facebookexternalhit)/i.test(
                    _ua,
                ),
        }
        stats.userAgent = _ua

        for (const key in stats.browser) {
            if (stats.browser[key] == true) {
                stats.browser.active = key
            }
        }
    }

    return stats
})()

document?.addEventListener('DOMContentLoaded', () => {
    stats.check_browser()

    const adblock_test = document.querySelectorAll('.adBlockTest')
    stats.object({
        event: 'adblock',
        adblock: !(adblock_test.length > 0),
    })
    stats.object({
        event: 'useragent',
        browser: stats.browser.active,
        browser_version: stats.browser.version,
        useragent: stats.userAgent,
    })
})
